export const LOAD_SITE_CONSTANTS = 'LOAD_SITE_CONSTANTS';

export const LOAD_SYSTEM_INFO_SUCCESS = 'LOAD_SYSTEM_INFO_SUCCESS';

export const LOAD_CONTENT_SUCCESS = 'LOAD_CONTENT_SUCCESS';
export const LOAD_CONTENT_FAILURE = 'LOAD_CONTENT_FAILURE';

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const RENEW_USER_SESSION = 'RENEW_USER_SESSION';

export const IMPERSONATE_SUCCESS = 'IMPERSONATE_SUCCESS';
export const UNIMPERSONATE_SUCCESS = 'UNIMPERSONATE_SUCCESS';

export const IMPERSONATE_COUNTRY_SUCCESS = 'IMPERSONATE_COUNTRY_SUCCESS';
export const UNIMPERSONATE_COUNTRY_SUCCESS = 'UNIMPERSONATE_COUNTRY_SUCCESS';
export const SAVE_PREVIOUS_LOCATION = 'SAVE_PREVIOUS_LOCATION';

export const LOAD_LOGS = 'LOAD_LOGS';
export const LOAD_LOGS_SUCCESS = 'LOAD_LOGS_SUCCESS';
export const LOAD_LOGS_FAILED = 'LOAD_LOGS_FAILED';

export const LOAD_LANGUAGE_SUCCESS = 'LOAD_LANGUAGE_SUCCESS';

export const ORDER_SELECTED = 'ORDER_SELECTED';

// Download actions
export const DOWNLOAD_STARTED = 'DOWNLOAD_STARTED';
export const DOWNLOAD_PROGRESS = 'DOWNLOAD_PROGRESS';
export const DOWNLOAD_INIT_PROGRESS = 'DOWNLOAD_INIT_PROGRESS';
export const DOWNLOAD_COMPLETED = 'DOWNLOAD_COMPLETED';
export const DOWNLOAD_ERROR = 'DOWNLOAD_ERROR';
export const DOWNLOAD_PROGRESS_NOT_SUPPORTED = 'DOWNLOAD_PROGRESS_NOT_SUPPORTED';
